<template>
    <div class="discounts_section">
        <i class="uis uis-percentage"></i>
        <h2>Discounts</h2>
        <h2>This section is under construction</h2>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.discounts_section {
    padding-top: 2rem;

    i {
        font-size: 2rem;
    }
}
</style>